module.exports = __webpack_public_path__ + "static/media/chevrolet-4-onix-premier-preto-ouro-negro.57b7ecd4.png";